import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgeCheck, faStar, faTags } from '@fortawesome/pro-solid-svg-icons';
import ArrayMap from '../../lib/ArrayMap/ArrayMap';
import { Heading } from '../../flayr-components';

interface IReasonsToBookProps {
  reasons?: { title: string; label: string; icon?: React.ReactChild }[];
  bordered?: boolean;
}

const defaultReasons = [
  {
    title: 'Booking guaranteed',
    desc: 'Book with just a deposit with the rest payable on the day',
    icon: (
      <span className="text-2xl">
        <FontAwesomeIcon icon={faBadgeCheck} />
      </span>
    ),
    types: ['makeup'],
  },
  {
    title: 'Book a specific hairdresser',
    desc: 'See the work of the hairdresser and book them in',
    types: ['haircut'],
  },
  {
    title: 'Verified Reviews',
    desc: 'Read reviews from other customers',
    types: ['makeup', 'haircut'],
    icon: <FontAwesomeIcon icon={faStar} />,
  },
  {
    title: 'Fixed Pricing',
    desc: 'Price shown covers everyone in the search',
    types: ['makeup'],
    icon: <FontAwesomeIcon className="mt-2" icon={faTags} />,
  },
  {
    title: 'Fixed Pricing',
    desc: 'Price shown covers the services in the search',
    types: ['haircut'],
  },
].filter((r) => r.types.includes('makeup'));
const ReasonsToBook: React.FC<React.PropsWithChildren<IReasonsToBookProps>> = ({
  reasons = defaultReasons,
}) => {
  return (
    <div>
      <Heading
        tag="h2"
        className="mb-5 lg:text-center lg:mb-[60px] lg:text-2xl leading-[1.5em]"
        size="lg"
      >
        Great reasons to book with Flayr
      </Heading>

      <div className="grid gap-8 py-px mt-8 lg:grid-cols-3">
        <ArrayMap
          items={reasons}
          render={(item, idx) => <ReasonItem key={idx} {...item} />}
        />
      </div>
    </div>
  );
};
export default ReasonsToBook;

const ReasonItem: React.FC<React.PropsWithChildren<{
  title: string;
  desc: string;
  icon?: React.ReactNode;
}>> = ({ title, desc, icon }) => {
  return (
    <div
      style={{
        boxShadow: '0px 22px 83px rgba(0, 0, 0, 0.08)',
      }}
      className="flex flex-col w-full p-5 bg-white border lg:p-8 border-gray-50 rounded-3xl"
    >
      <div className="flex items-center space-x-3">
        {!!icon && (
          <span className="grid text-xl rounded-full w-9 h-9 bg-gray-F9 text-primary place-items-center group">
            <span className="transition-transform ease-in lg:group-hover:-rotate-12 will-change-transform">
              {icon}
            </span>
          </span>
        )}
        <h4 className="text-lg leading-[1.5em]">{title}</h4>
      </div>
      <p className="text-sm leading-7 text-gray-5E mt-2.5  min-h-[4em]">
        {desc}
      </p>
    </div>
  );
};
